// Updates from before the changelog moved into Firestore (they used to be
// hard-coded in the old What's New modal). The Updates tab on /feedback shows
// these after the changelog entries posted from the admin dashboard.
const pastUpdates = [
  {
    date: "2026-09-01",
    title: "NameIt Run",
    items: [["New mini-game", "Warm up at /run with a fast word runner, daily challenges, and a weekly ranking."]],
  },
  {
    date: "2026-02-01",
    title: "NameIt! Pro",
    items: [
      ["Pro subscription", "More players per room, unlimited room creations, special rounds always unlocked, unlimited dictionary checks, custom timer up to 120s, and 200 bonus coins every month."],
      ["Dictionary limit", "Free players get 5 dictionary lookups per game. Pro players get unlimited."],
    ],
  },
  {
    date: "2025-08-09",
    title: "Letter Picker",
    items: [["Letter Picker", "Players can choose the letter for each round instead of a random one. The host turns it on in game settings."]],
  },
  {
    date: "2025-08-04",
    title: "Custom timer and more categories",
    items: [
      ["Custom round timer", "Hosts can adjust the timer for each round in game settings."],
      ["More categories", "Hosts can add up to 4 more categories (8 in total)."],
    ],
  },
  {
    date: "2025-07-25",
    title: "Coins and bigger rooms",
    items: [
      ["Increase room players", "Hosts can spend coins to add more players to their rooms."],
      ["Coins", "Buy coins to upgrade room capacity."],
    ],
  },
  {
    date: "2025-07-19",
    title: "My Rooms and Force End Round",
    items: [
      ["View My Rooms", "See the rooms you've hosted or joined recently and rejoin your current games."],
      ["Force End Round", "Hosts can move the game forward when players get stuck."],
    ],
  },
  {
    date: "2025-07-16",
    title: "First submit stops the timer",
    items: [["First submit stops the timer", "The first person to submit can stop the countdown, so everyone else submits what they have."]],
  },
  {
    date: "2025-07-15",
    title: "Bug fixes",
    items: [
      ["Reconnecting", "Disconnected players can rejoin games in progress."],
      ["Review phase", "Games no longer get stuck when players leave during review."],
    ],
  },
  {
    date: "2025-05-31",
    title: "Chat and dictionary",
    items: [
      ["Real-time chat", "Chat with other players without leaving the game."],
      ["Dictionary", "Get definitions and check whether a word fits the category."],
    ],
  },
  {
    date: "2025-05-25",
    title: "Special rounds and speed mode",
    items: [
      ["Special rounds", "Random effects make the game more challenging."],
      ["Speed mode", "The final 6 rounds drop the timer to 20 seconds."],
    ],
  },
  {
    date: "2025-05-21",
    title: "Custom categories",
    items: [["Custom categories", "Create your own categories beyond the classic four."]],
  },
];

export default pastUpdates;
